import type React from 'react'
import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { LanguageContext } from '../util/LanguageContext'
import './SlideMenu.css'
import { useContext } from 'react'

type SlideMenuProps = {
  label: string
  page: string
  smallFont: boolean
}

export const SlideMenu: React.FC<SlideMenuProps> = props => {
  const label = props.label
  const auth = useAuth()
  const [checked, setChecked] = useState(false)
  const navigate = useNavigate()
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
    navigate(props.page)
  }

  const Tag = props.smallFont ? <span className="smallFont">{label}</span> : <span>{label}</span>
  useEffect(() => {
    const containsPage = window.location.pathname.includes(props.page)
    setChecked(containsPage)
  }, [props.page])

  //多言語化対応
  const userLanguage = navigator.language || navigator.languages[0]
  const baseLanguage = userLanguage.split('-')[0]
  let slideMenuJsx: JSX.Element
  switch (baseLanguage) {
    case 'sv':
    case 'de':
      slideMenuJsx = (
        <li>
          {label === translation['label_logout'] ? (
            <label className="slidein localization" id="label-logtout">
              <input
                disabled={auth.isDisable}
                type="radio"
                checked={checked}
                onChange={handleChange}
                className="small-font"
              />
              {Tag}
            </label>
          ) : (
            <label className="slidein localization">
              <input
                disabled={auth.isDisable}
                type="radio"
                checked={checked}
                onChange={handleChange}
              />
              {Tag}
            </label>
          )}
        </li>
      )
      break
    default:
      slideMenuJsx = (
        <li>
          {label === translation['label_logout'] ? (
            <label className="slidein" id="label-logtout">
              <input
                disabled={auth.isDisable}
                type="radio"
                checked={checked}
                onChange={handleChange}
              />
              {Tag}
            </label>
          ) : (
            <label className="slidein">
              <input
                disabled={auth.isDisable}
                type="radio"
                checked={checked}
                onChange={handleChange}
              />
              {Tag}
            </label>
          )}
        </li>
      )
      break
  }

  return <>{slideMenuJsx}</>
}
